import { createContext, type PropsWithChildren, useContext } from 'react'
import { type BreakdownFilterStore } from '../store/breakdownFilterStore'

export const BreakdownFilterContext = createContext<BreakdownFilterStore | null>(null)

export function useBreakdownFilterContext() {
  const context = useContext(BreakdownFilterContext)
  if (context === null) {
    throw new Error(
      'You have forgotten to wrap your root component with BreakdownFilterStoreProvider'
    )
  }
  return context
}

export const BreakdownFilterStoreProvider = ({
  children,
  store,
}: PropsWithChildren & { store: BreakdownFilterStore }) => {
  return <BreakdownFilterContext.Provider value={store}>{children}</BreakdownFilterContext.Provider>
}
